import { Amplify } from "aws-amplify";
import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import initAuthHub from "./services/AuthHub";

ReactGA.initialize(process.env.REACT_APP_TRACKING_ID as string);

// refer to https://docs.amplify.aws/javascript/build-a-backend/auth/set-up-auth/
Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: process.env.IdentityPoolId as string,
      userPoolId: process.env.UserPoolId as string,
      userPoolClientId: process.env.UserPoolClientId as string,
      loginWith: {
        oauth: {
          domain: process.env.AppWebDomain as string,
          redirectSignIn: [process.env.RedirectUriSignIn as string],
          redirectSignOut: [process.env.RedirectUriSignOut as string],
          scopes: ["openid", "profile"],
          responseType: "code",
        },
      },
    },
  },
});

initAuthHub();

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
